<template>
  <!-- <el-row class='qrcode' justify="center" align="middle">
        <el-col :span='24'>
     <el-image
        style="width: 100%; height: 100%"
        :src="qrcode"
        :fit="fit"
        v-if="vis"
      ></el-image>
      </el-col>
    </el-row> -->
  <el-row justify="center" align="middle">
    <el-col :span="24" v-if="scan == 1">
      <el-row justify="center" align="middle">
        <div style="width: 300px; height: 0px; z-index: 999">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 300px;
              height: 300px;
              background-color: #000000;
              color: #00ff00;
              opacity: 0.8;
            "
          >
            <el-icon><i-camera /></el-icon>&nbsp; 已扫码，请确认
          </div>
        </div>
      </el-row>
    </el-col>
    <el-col :span="24">
      <el-row justify="center" align="middle">
        <el-image
          style="width: 300px; height: 300px"
          :src="qrcode"
          :fit="fit"
          v-if="vis"
        ></el-image>
      </el-row>
    </el-col>
    <el-col :span="24" v-if="isWechat==1">
      长按小程序码，识别登录
    </el-col>
    <el-col :span="24">
      <el-result
        :icon="icon"
        title="扫码登录"
        sub-title="扫描小程序码，识别身份登录"
      ></el-result>
    </el-col>
  </el-row>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "login",
  components: {
    // HelloWorld
  },
  data() {
    return {
      isWechat: 0,
      qrcode: "",
      fit: "cover",
      vis: false,
      icon: "info",
      imageToken: "",
      scan: 0,
      qt: "",
    };
  },
  async created() {
    console.log("created");
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") > -1) {
      this.isWechat = 1;
    }
    let token = localStorage.getItem("report_token");
    try {
      let res = await fetch("https://www.rosegun.com/wechat/info", {
        headers: { Authorization: token },
      });
      if (res.status == 401) {
        throw new Error("Permission denied.");
      }
      let data = await res.json();
      console.log("login: %o", data);

      this.$router.push("/");
    } catch (e) {
      console.warn(e.message);
    }
    this.qt = this.$route.query.qt;
    if (this.qt) {
      localStorage.setItem("qt", this.qt);
    }
    let _self = this;
    fetch("https://www.rosegun.com/wechat/qrcode", {
      headers: { qt: localStorage.getItem("qt") || "" },
    })
      .then((res) => res.arrayBuffer())
      .then((b) => {
        _self.vis = true;
        let blob = new Blob([b.slice(32)], { type: "image/jpeg" });
        _self.qrcode = URL.createObjectURL(blob);
        // console.log(this.qrcode);
        let sceneArr = new Uint8Array(b.slice(0, 32));
        let scene = String.fromCharCode.apply(null, sceneArr);
        console.log(scene);
        _self.imageToken = scene;
        let inter = setInterval(() => {
          fetch("https://www.rosegun.com/wechat/logon", {
            headers: { "Image-Token": scene },
          })
            .then((res) => {
              if (res.status > 300) {
                throw new Error("登录失败");
              }
              return res.text();
            })
            .then((txt) => {
              if (txt) {
                console.log(txt);
                if (txt == "1") {
                  if (_self.scan == 0) {
                    _self.scan = 1;
                  }
                } else {
                  _self.icon = "success";
                  console.log(txt);
                  localStorage.setItem("report_token", txt);
                  clearInterval(inter);
                  this.$router.push("/");
                }
              }
            })
            .catch((e) => {
              console.error(e);
              clearInterval(inter);
            });
        }, 500);
      });
  },
};
</script>

<style>
/* .qrcode {
  text-align: center;
  width: 300px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
} */
</style>
